// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2gtRm","techList":"styles_techList__3pjs_","record":"styles_record__3xJE4"};